module["exports"] = [
  "##-#######",
  "+977-#-#######",
  "+977########"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nep/phone_number/formats.js
// module id = 1038
// module chunks = 0